import {
    IonContent,
    IonPage,
} from "@ionic/react";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Screens, useAnalytics } from "../AppAnalyticsProvider";
import { AppContext } from "../AppStateProvider";
import BiskTransactionList from "../components/ComponentsBisk/BiskTransactionList/BiskTransactionList";
import BoardResultsList from "../components/ComponentsBoard/BoardResultsList/BoardResultsList";
import CrewListContainer from "../components/ComponentsCrew/CrewListContainer/CrewListContainer";
import EventListContainer from "../components/ComponentsEvent/EventListContainer/EventListContainer";
import CustomHelmet from "../components/ComponentsFunctional/CustomHelmet/CustomHelmet";
import ShopRedirect from "../components/ComponentsPurchases/ShopRedirect/ShopRedirect";
import ToolbarSearchBarCommunity from "../components/ComponentsUI/ToolbarSearchBarCommunity/ToolbarSearchBarCommunity";
import { useBlur } from "../hooks/useBlur";
import useResizeObserverErrorHandler from "../hooks/useResizeObserverHandler";
import { useRevenueCatPaywall } from "../hooks/useRevenueCatPaywall";

const Community: React.FC = () => {
    const history = useHistory();
    useResizeObserverErrorHandler();
    const { state } = useContext(AppContext);
    const { trackScreen } = useAnalytics();

    const [segmentValue, setSegmentValue] = useState(undefined);

    const { blurred, blurredClass } = useBlur();

    // Fire screen_view once on mount so this surface shows up in the
    // engagement dashboard. Previously this page was silent — top-screens
    // reporting had no data for it.
    useEffect(() => {
        trackScreen(Screens.COMMUNITY);
    }, [trackScreen]);

    const handleSegmentChange = async (value: string) => {
        setSegmentValue(value);
    }

    const {
        presentPaywall: presentTowRopePaywall,
    } = useRevenueCatPaywall({
        userId: state.user.id,
        userBisk: state.bisk,
        username: state.user.username
    });

    const onShopRedirect = async () => {
        return await presentTowRopePaywall();
    }

    return (
        <IonPage>
            <CustomHelmet title={"Ecliptic // Community"}
                description={"View the Ecliptic community and see all the different park crews around the world"}
                url={`https://ecliptic.day/community`} />
            <ToolbarSearchBarCommunity handleSegmentChange={handleSegmentChange}></ToolbarSearchBarCommunity>
            <IonContent>
                {
                    segmentValue === 'events' ?
                        <>
                            <EventListContainer />
                        </>
                        :
                        segmentValue === 'crews' ?
                            <>
                                <CrewListContainer />
                            </>
                            :
                            segmentValue === 'bisk' ?
                                <>
                                    <BiskTransactionList
                                        blurred={blurred}
                                        onShopRedirect={onShopRedirect} />
                                </>
                                : segmentValue === 'board' ?
                                    <>
                                        <BoardResultsList
                                            blurred={blurred}
                                            onShopRedirect={onShopRedirect} />
                                    </> :
                                    <>
                                        {
                                            <IonContent scrollY={false}>
                                                {
                                                    blurred ?
                                                        <div className="flex flex-col align-middle items-center my-1 mx-4">
                                                            <ShopRedirect
                                                                title={"Head to the Smoke Shack and Sign Up for the Tow Rope Pass to View the Leaderboards!"}
                                                                shopRedirect={onShopRedirect} />
                                                        </div> : <div></div>
                                                }
                                                <div className={blurredClass + " flex flex-row justify-center m"}>
                                                    Coming soon!
                                                </div>
                                            </IonContent>
                                        }
                                    </>
                }
            </IonContent>
        </IonPage>
    );
};

export default Community;